// sessions/utils/revenue.js
export const calculateRevenue = ({ row }) => {
  if (!row?.original) return "—";

  const energyRaw = row.original.EnergyConsumed;
  if (!energyRaw) return "—";

  const cost = row.original.costPerUnit?.amount || 0;
  const currency = row.original.costPerUnit?.currency || "";

  const wh = parseFloat(
    String(energyRaw).replace(/wh/i, "").trim()
  );

  if (Number.isNaN(wh)) return "—";

  const kwh = wh / 1000;
  const revenue = (kwh * cost * 1000).toFixed(2);

  return `${currency} ${revenue}`;
};
